import { useState } from "react";
import { put } from "../../../common/api/apiShared";
import { useTranslation } from "../../../localization/useTranslation";
import { useValidator } from "../../../common/hooks/validation";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { ISetMonthlySpendingLimitDialog } from "./SetMonthlySpendingLimitDialog";
import { SetMonthlySpendingLimitSaveModel } from "./SetMonthlySpendingLimitDialog.types";

export function useSetMonthlySpendingLimitDialogHooks(props: ISetMonthlySpendingLimitDialog) {
    const { translateString } = useTranslation();
    const [model, setModel] = useState<SetMonthlySpendingLimitSaveModel>({
        limit: props.currentLimit?.toString() ?? "",
    });

    const validation = useValidator<SetMonthlySpendingLimitSaveModel>((validators) => ({
        limit: validators.validateNotEmpty((item) => item.limit, translateString("monthlySpendingLimit")),
    }));

    const saveMutation = useDotLegalMutation(save, {
        onSuccess: () => props.onLimitSaved(),
    });

    function save() {
        return put<{}>("/ai-administration/monthly-spending-limit", { limit: Number(model.limit) });
    }

    const onSaveClick = () => {
        if (validation.anyHasErrors) {
            validation.setShowErrors(true);
            return;
        }

        saveMutation.mutateAsync();
    };

    const onLimitChange = (limit: string) => {
        setModel({ ...model, limit });
    };

    return {
        model,
        onLimitChange,
        onSaveClick,
        inProgress: saveMutation.isLoading,
        validation,
    };
}
